import axios from 'axios';

import qs from 'qs';

axios.defaults.headers.common.Accept = 'application/json';

const api = axios.create({
  baseURL: '/api/v0',
  paramsSerializer: qs.stringify.bind(qs),
  withCredentials: true
});

function get(url: string, ...args: any[]) {
  return api.get(url, ...args);
}

function post(url: string, ...args: any[]) {
  return api.post(url, ...args);
}

function put(url: string, ...args: any[]) {
  return api.put(url, ...args);
}

function patch(url: string, ...args: any[]) {
  return api.patch(url, ...args);
}

function del(url: string, ...args: any[]) {
  return api.delete(url, ...args);
}

function login(token: string) {
  api.defaults.headers.Authorization = 'Bearer ' + token;
}

function clearLogin() {
  delete api.defaults.headers.Authorization;
}

const Api = {
  get,
  post,
  put,
  patch,
  delete: del,
  login,
  clearLogin
};

export default Api;
